import axios from 'src/utils/axios';
import { addNotification } from 'src/actions/notificationActions';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';

export const SET_CURRENT_NAVIGATION_TAB = '@groupSettings/set-current-navigation-tab';
export const SET_GROUP_TYPES_QUERY = '@groupSettings/set-group-types-query';
export const SET_VISIBLE_MODAL_FORM_NUMBER = '@groupSettings/set-visible-modal-form-number';

export const GET_GROUP_TYPES_LIST = '@groupSettings/get-group-types-list';
export const GET_GROUP_TYPES_LIST_SUCCESS = '@groupSettings/get-group-types-list-success';
export const GET_GROUP_TYPES_LIST_ERROR = '@groupSettings/get-group-types-list-error';
export const CLEAR_GROUP_TYPES_LIST = '@groupSettings/clear-group-types-list';

export const VERIFY_CODE = '@groupSettings/verify-code';
export const VERIFY_CODE_SUCCESS = '@groupSettings/verify-code-success';
export const VERIFY_CODE_ERROR = '@groupSettings/verify-code-error';

export const APPLY_SHARE_CODE = '@groupSettings/apply-share-code';
export const APPLY_SHARE_CODE_SUCCESS = '@groupSettings/apply-share-code-success';
export const APPLY_SHARE_CODE_ERROR = '@groupSettings/apply-share-code-error';
export const SET_VALUES_FORM_APPLY_SHARE_CODE = '@groupSettings/set-values-form-apply-share-code';

export const SET_BACK_TO_GROUP_TYPES_LIST = '@groupSettings/set-back-to-group-types-list';

export const DUPLICATE_GROUP_TYPE = '@groupSettings/duplicate-group-type';
export const DUPLICATE_GROUP_TYPE_SUCCESS = '@groupSettings/duplicate-group-type-success';
export const DUPLICATE_GROUP_TYPE_ERROR = '@groupSettings/duplicate-group-type-error';

export const SET_MODAL_MESSAGE = '@groupSettings/set-modal-message';

export const CHANGE_GROUP_TYPE_STATUS = '@groupSettings/change-group-type-status';
export const CHANGE_GROUP_TYPE_STATUS_SUCCESS = '@groupSettings/change-group-type-status-success';
export const CHANGE_GROUP_TYPE_STATUS_ERROR = '@groupSettings/change-group-type-status-error';

export const setCurrentNavigationTab = (tabName) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tabName
});

export const setGroupTypesQuery = (query) => ({
  type: SET_GROUP_TYPES_QUERY,
  payload: query
});

export const setVisibleModalFormNumber = (modalNumber) => ({
  type: SET_VISIBLE_MODAL_FORM_NUMBER,
  payload: modalNumber
});

export const setModalMessage = (isVisible, modalTitle, modalBody) => ({
  type: SET_MODAL_MESSAGE,
  payload: {
    isVisible,
    modalTitle,
    modalBody,
  },
});

export const getGroupTypesList = () => async (dispatch, getState) => {
  dispatch({
    type: GET_GROUP_TYPES_LIST,
  });
  try {
    const query = getState()?.groupSettings?.query || {};
    const response = await axios.post('/api/groupSettings/grouptypes', query);

    dispatch({
      type: GET_GROUP_TYPES_LIST_SUCCESS,
      payload: response?.data || [],
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_TYPES_LIST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_TYPES_LIST_ERROR,
    });
  }
};

export const clearGroupTypesList = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GROUP_TYPES_LIST,
  });
};

export const verifyCode = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: VERIFY_CODE,
    });
    const {
      formApplyShareCode,
    } = getState()?.groupSettings || {};
    const {
      shareCode,
    } = formApplyShareCode || {};
    const response = await axios.post('/api/groupSettings/grouptypes/verifyShareCode', { shareCode });
    const {
      groupTypeName,
    } = response?.data || {};

    if (!groupTypeName) {
      dispatch(addNotification(VERIFY_CODE_ERROR, 'Could Not Verify Share Code', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: VERIFY_CODE_ERROR,
      });
      return;
    }

    dispatch(addNotification(VERIFY_CODE_SUCCESS, 'Valid Share Code - You Can Apply Now', NOTIFICATION_STATUS.SUCCESS));

    dispatch({
      type: VERIFY_CODE_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(VERIFY_CODE_ERROR, message || errorMessage || error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: VERIFY_CODE_ERROR,
    });
  }
};

export const applyShareCode = (doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: APPLY_SHARE_CODE,
    });
    const {
      partyId,
      formApplyShareCode
    } = getState()?.groupSettings || {};
    const {
      shareCode,
    } = formApplyShareCode || {};
    const params = {
      partyId,
      shareCode,
    };
    const response = await axios.post('/api/groupSettings/grouptypes/applyShareCode', { params });
    const {
      id,
    } = response?.data || {};

    if (!id) {
      dispatch(addNotification(APPLY_SHARE_CODE_ERROR, 'Can not create group type', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: APPLY_SHARE_CODE_ERROR,
      });
      return;
    }

    dispatch(addNotification(APPLY_SHARE_CODE_SUCCESS, 'Your group type has been successfully created', NOTIFICATION_STATUS.SUCCESS));

    dispatch({
      type: APPLY_SHARE_CODE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(APPLY_SHARE_CODE_ERROR, message || errorMessage || error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: APPLY_SHARE_CODE_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

/**
 * Row-kebab duplicate. The server copies the caller's own type via the
 * same-user share-code path and echoes the generated name.
 */
export const duplicateGroupType = (id, onSuccess, onError) => async (dispatch) => {
  try {
    dispatch({ type: DUPLICATE_GROUP_TYPE });
    const response = await axios.post(`/api/groupSettings/grouptypes/${id}/duplicate`);
    const { id: newId, generatedName } = response?.data || {};

    dispatch({ type: DUPLICATE_GROUP_TYPE_SUCCESS });
    dispatch(addNotification(
      DUPLICATE_GROUP_TYPE_SUCCESS,
      generatedName
        ? `Group Type "${generatedName}" has been successfully created`
        : 'Your group type has been successfully created',
      NOTIFICATION_STATUS.SUCCESS,
    ));

    if (onSuccess) onSuccess(newId);
  } catch (e) {
    const { error, message, modalBody } = e?.response?.data || {};
    const bodyText = Array.isArray(modalBody) ? modalBody.join(' ') : modalBody;
    dispatch({ type: DUPLICATE_GROUP_TYPE_ERROR });
    dispatch(addNotification(
      DUPLICATE_GROUP_TYPE_ERROR,
      helpers.transform.toString(bodyText || message || error || 'Try again later'),
      NOTIFICATION_STATUS.ERROR,
    ));
    if (onError) onError(e);
  }
};

/**
 * Row-kebab status toggle. Reuses the existing group type update endpoint,
 * which applies only the fields supplied and already guards inactivation
 * when active groups exist (403 + modal copy).
 */
export const changeGroupTypeStatus = (id, status, onSuccess, onError) => async (dispatch) => {
  try {
    dispatch({ type: CHANGE_GROUP_TYPE_STATUS });
    await axios.put('/api/groupSettings/grouptypes', {
      groupTypeChanges: { id, status },
    });

    dispatch({ type: CHANGE_GROUP_TYPE_STATUS_SUCCESS });
    dispatch(addNotification(
      CHANGE_GROUP_TYPE_STATUS_SUCCESS,
      `Group Type has been set to ${status}`,
      NOTIFICATION_STATUS.SUCCESS,
    ));

    if (onSuccess) onSuccess();
  } catch (e) {
    const {
      error, message, modalTitle, modalBody
    } = e?.response?.data || {};
    dispatch({ type: CHANGE_GROUP_TYPE_STATUS_ERROR });

    // The server blocks inactivating a type that still has active groups and
    // answers 403 with modalTitle + modalBody explaining what to do. Surface
    // that as a modal (same treatment as the group type detail page), not a
    // toast that truncates the instructions.
    if (modalBody) {
      dispatch(setModalMessage(true, modalTitle, modalBody));
    } else {
      dispatch(addNotification(
        CHANGE_GROUP_TYPE_STATUS_ERROR,
        helpers.transform.toString(message || error || 'Try again later'),
        NOTIFICATION_STATUS.ERROR,
      ));
    }
    if (onError) onError(e);
  }
};

export const setValuesFormApplyShareCode = (values) => ({
  type: SET_VALUES_FORM_APPLY_SHARE_CODE,
  payload: values
});

export const setBackToGroupTypesList = (payload) => ({
  type: SET_BACK_TO_GROUP_TYPES_LIST,
  payload,
});

export const clearBackToGroupTypesList = (clearAll = false) => ({
  type: SET_BACK_TO_GROUP_TYPES_LIST,
  payload: !clearAll ? {
    partyTypes: [],
    query: {},
  } : false,
});
